<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer037">
<p class="Graphic" lang="en-GB" xml:lang="en-GB"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/binosaur.jpg"/></p>
<p class="Prelim-head-2">ABOUT THE AUTHORS</p>
<p class="Prelim-main">David and Stephen are identical twins. They were both children’s doctors, but now they are so old that they have been reclassified as dinosaurs. David is a Daveosaurus, Stephen is a Steveodactyl. </p>
<p class="Prelim-main">Their book is for all ages. They want dinosaurs to feel better about human beings.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035845781_EPUB.vue?c4b712de